import { render, staticRenderFns } from "./BreadcrumbItem.global.vue?vue&type=template&id=1a11aaa0&scoped=true&lang=pug&"
import script from "./BreadcrumbItem.global.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbItem.global.vue?vue&type=script&lang=ts&"
import style0 from "./BreadcrumbItem.global.vue?vue&type=style&index=0&id=1a11aaa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a11aaa0",
  null
  
)

export default component.exports